import { Separator } from 'app/components/ui/Separator'
import { Text } from 'app/components/ui/Text'
import { themeEstra } from 'app/styles/themeEstra'
import React from 'react'
import styled from 'styled-components'

export const FormSection = ({
  title,
  children,
}: {
  title?: string
  children?: React.ReactNode
}) => {
  return (
    <FormSectionWrapper>
      {title && (
        <>
          <Text
            variant='s20'
            weight='700'
            mb={0.5}
            color={themeEstra.color.primari.grigioEstra}
          >
            {title}
          </Text>
          <FormSectionSeparator></FormSectionSeparator>
        </>
      )}
      {children}
    </FormSectionWrapper>
  )
}

const FormSectionWrapper = styled.div`
  margin-bottom: 3rem;
`

const FormSectionSeparator = styled(Separator)`
  margin-bottom: 1rem;
`
